<template>
<div class="chapter">
<div class="inner_page">
<p class="p_toc_heading" id="tableofcontents">Table of Contents</p>
<p class="p_toc_entry_"><a href="#/OPS/section0002#auto_bookmark_toc_1">Blurb</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0003#auto_bookmark_toc_1">Dedication</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0004#auto_bookmark_toc_1">Acknowledgments</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0005#auto_bookmark_toc_1">Prologue</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0006#auto_bookmark_toc_1">Chapter One</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0007#auto_bookmark_toc_1">Chapter Two</a></p>
<p class="p_toc_entry_"><a href="#/OPS/section0008#auto_bookmark_toc_1">Chapter Three</a></p>
<p class="p_toc_entry_"><span href="#/OPS/section0009#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Four</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0010#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Five</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0011#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Six</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0012#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0013#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0014#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Nine</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0015#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Ten</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0016#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Eleven</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0017#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Twelve</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0018#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Thirteen</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0019#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Fourteen</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0020#auto_bookmark_toc_1" title="Link target outside of Sample">Chapter Fifteen</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0021#auto_bookmark_toc_1" title="Link target outside of Sample">More from John R. Petrie</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0022#auto_bookmark_toc_1" title="Link target outside of Sample">About the Author</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0023#auto_bookmark_toc_1" title="Link target outside of Sample">By John R. Petrie</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0024" title="Link target outside of Sample">Visit Harmony Ink Press</span></p>
<p class="p_toc_entry_"><span href="#/OPS/section0025#auto_bookmark_toc_2" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?285635c2